module.exports = __webpack_public_path__ + "img/MK.9bdfb8b3.svg";